























import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Main extends Vue {
  fixedIcon: boolean = false
  path: any = {}
  iconList: any = [
    { name: '返回首页', img: require('@/image/back_home.png') },
    { name: '返回上一页', img: require('@/image/back.png') }
  ]
  flags: boolean = false
  position: any = { x: 0, y: 0 }
  nx: any = ''
  ny: any = ''
  dx: any = ''
  dy: any = ''
  xPum: any = ''
  yPum: any = ''
  mounted() {
    ;(this as any).$wechartfunc()
  }
  onClickIcon(index: number) {
    if (index == 0) {
      // this.$router.push(
      //   Number(this.$global.tenantType) == 2 ? '/home' : '/manageHome'
      // )
      this.$router.push('/home')
    } else {
      let path: string = this.path.path
      // if (path == "/mine/shop/accountmanage") {
      //   this.$router.push("/mine/shop");
      //   return;
      // }
      // if (path == "/mine/market/accountmanage") {
      //   this.$router.push("/mine/market");
      //   return;
      // }
      // if (path == "/couponVerification/search") {
      //   this.$router.push("/couponVerification");
      //   return;
      // }
      this.$router.back()
    }
  }
  down() {
    this.flags = true
    var touch
    let moveDiv: any = document.querySelector('#moveDiv')
    if ((event as any).touches) {
      touch = (event as any).touches[0]
    } else {
      touch = event
    }
    this.position.x = touch.clientX
    this.position.y = touch.clientY
    this.dx = moveDiv.offsetLeft
    this.dy = moveDiv.offsetTop
  }
  move() {
    if (this.flags) {
      var touch
      if ((event as any).touches) {
        touch = (event as any).touches[0]
      } else {
        touch = event
      }
      this.nx = touch.clientX - this.position.x
      this.ny = touch.clientY - this.position.y
      this.xPum = this.dx + this.nx
      this.yPum = this.dy + this.ny
      let moveDiv: any = document.querySelector('#moveDiv')
      if (this.xPum <= 0) {
        this.xPum = 0
      } else if (
        this.xPum >=
        document.documentElement.clientWidth - moveDiv.offsetWidth
      ) {
        // 屏幕的可视宽度
        this.xPum = document.documentElement.clientWidth - moveDiv.offsetWidth
      }
      if (this.yPum <= 0) {
        this.yPum = 0
      } else if (
        this.yPum >=
        document.documentElement.clientHeight - moveDiv.offsetHeight
      ) {
        this.yPum = document.documentElement.clientHeight - moveDiv.offsetHeight
      }
      moveDiv.style.left = this.xPum + 'px'
      moveDiv.style.top = this.yPum + 'px'
      //阻止页面的滑动默认事件
      document.addEventListener(
        'touchmove',
        function() {
          ;(event as any).stopPropagation()
        },
        false
      )
    }
  }
  //鼠标释放的函数
  end() {
    this.flags = false
  }
  @Watch('$route', { immediate: true })
  private changeRouter(route: any) {
    this.path = route
    this.fixedIcon =
      route.path == '/' ||
      route.path == '/home' ||
      route.path == '/manageHome' ||
      route.path == '/mine/shop' ||
      route.path == '/mine/market'
        ? false
        : true
  }
}
